

// depLocation is dependency location for testing cases
export const switchENV = (envUrl, depLocation) => {
    const location = depLocation || document.location.origin;
    const production = process.env.REACT_APP_ENV === 'production';
    if (production) {
        switch (location) {
            case process.env.REACT_APP_INTERNAL_DEV:
            case process.env.REACT_APP_DEV:
                return envUrl.dev;

            case process.env.REACT_APP_INTERNAL_STAGE:
            case process.env.REACT_APP_STAGE:
                return envUrl.stage;

            case process.env.REACT_APP_INTERNAL_PROD:
            case process.env.REACT_APP_PROD:
                return envUrl.prod;

            default:
                return envUrl.dev;
        }
    } else {
        return envUrl.dev;
    }
};

export const externalLinkEnvUrl = {
    dev: 'https://wwwdev.troweprice.com',
    stage: 'https://wwwstage.troweprice.com',
    prod: 'https://www.troweprice.com'
};

export const externalEnvUrl = {
    dev: 'https://www3dev.troweprice.com',
    stage: 'https://www3qual.troweprice.com/',
    prod: 'https://www3.troweprice.com'
};

export const envApiConfig =
    process.env.REACT_APP_ENV === 'production'
        ? `${document.location.origin}/usis/advice/checkout/api-config.json?hash=${Math.random()}`
        : `${document.location.origin}/api-config.json`;

export const apiEnvUrl = {
    dev: 'https://api.dev.troweprice.com',
    stage: 'https://api.confidence.troweprice.com',
    prod: 'https://api.public.troweprice.com'
};

export const apiCloudEnvUrl = {
    dev: 'https://api.dev.awstrp.net',
    stage: 'https://api.stage.awstrp.net',
    prod: 'https://api.prod.awstrp.net'
}

export const footerProspectus = 'https://www.troweprice.com/personal-investing/funds/mutual-funds/prospectuses-reports.html';
export const footerETF = 'https://www.troweprice.com/personal-investing/funds/etfs/prospectuses-reports.html';
export const footerCostBasis = 'https://www.troweprice.com/content/dam/iinvestor/Forms/CostBasisForm.pdf';
export const rasADV = 'https://www.troweprice.com/content/dam/iinvestor/advice/retirement-advisory-service/t-rowe-price-retirement-advisory-service-form-adv.pdf';
